import { useState } from 'react';

import { ApiError } from '@solar/api-client';
import { isNative, nativeInfo } from '@solar/native-bridge';

export function Login({ onLogin }: { onLogin: (id: string, pw: string) => Promise<void> }) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await onLogin(userId.trim(), password);
    } catch (err) {
      // 아이디 존재 여부는 알려주지 않는다 — 서버도 같은 메시지를 준다.
      setError(err instanceof ApiError ? err.message : '로그인에 실패했습니다.');
    } finally {
      setBusy(false);
    }
  }

  const shell = nativeInfo();

  return (
    <form className="login" onSubmit={submit}>
      <h1>미니태양광 현장</h1>

      <label>
        아이디
        <input
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          autoComplete="username"
          autoCapitalize="none"
          inputMode="email"
          required
        />
      </label>

      <label>
        비밀번호
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
      </label>

      {error && <p className="error">{error}</p>}

      <button type="submit" className="primary" disabled={busy || !userId || !password}>
        {busy ? '로그인 중…' : '로그인'}
      </button>

      {/*
        레거시 앱은 '아이디 저장' 체크박스로 아이디와 비밀번호를 평문으로
        UserDefaults/SharedPreferences 에 남겼다. 여기서는 refresh 토큰만
        Keychain/Keystore 에 저장하므로 저장 옵션 자체가 없다.
      */}
      <p className="muted">
        {isNative() ? `앱 ${shell?.shellVersion ?? ''} (${shell?.platform ?? ''})` : '웹 브라우저'}
      </p>
    </form>
  );
}
